import { useState } from 'react';
import { Link } from 'react-router-dom';
import AuthShell from './AuthShell';
import { Field, Spinner } from '../../components/ui';
import { forgotPassword } from '../../api/auth';
import { useToast } from '../../context/ToastContext';

export default function ForgotPassword() {
  const toast = useToast();
  const [email, setEmail] = useState('');
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setErrors({});
    setSubmitting(true);
    try {
      await forgotPassword(email);
      setSent(true);
      toast.success('If that email exists, a reset link has been sent.');
    } catch (err) {
      setErrors(err.errors || {});
      toast.error(err.message || 'Could not send reset link.');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <AuthShell
      title="Reset your password"
      subtitle="Enter your email and we'll send you a link to reset your password."
      footer={
        <Link to="/login" className="font-semibold text-maroon-700 hover:underline">
          ← Back to sign in
        </Link>
      }
    >
      {sent ? (
        <div className="card bg-maroon-50 p-5 text-sm text-ink-soft">
          Check your inbox for a password reset link. It may take a few minutes to arrive.
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="space-y-5">
          <Field label="Email address" error={errors.email?.[0]}>
            <input
              type="email"
              className="input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </Field>
          <button type="submit" className="btn-primary w-full" disabled={submitting}>
            {submitting ? <Spinner className="h-4 w-4 text-white" /> : 'Send reset link'}
          </button>
        </form>
      )}
    </AuthShell>
  );
}
